module.exports = __webpack_public_path__ + "img/Feature.4a9de6df.jpg";